<template>
	<div>
		<el-button :disabled="disabled" @click="addKeywordsdialogVisible=true" 
		:size="size" type="primary" icon="el-icon-plus" circle></el-button>
		
		<el-dialog :show-close="false" append-to-body destroy-on-close 
			width="1200px" top="20px" v-if="addKeywordsdialogVisible"
			:visible.sync="addKeywordsdialogVisible" v-loading="addKeywordsLoading" >
			<div slot="title" style="text-align: right;">
				<el-button @click="addKeywordsdialogVisible=false"  type="danger" icon="el-icon-close" size="mini"></el-button>
			</div>
						
			<div>
				<div v-if="asinInfo">
					<goods-info-sub :asinInfo="asinInfo"></goods-info-sub>
				</div>
				<div style="margin-top: 30px;">
					<add-keywords-sub :asinId="asinInfo.id" :addedKeywords="keyword" @getKeywords="setKeywords"></add-keywords-sub>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="danger" @click="addKeywordsdialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitRetrieve(null)">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { api_submitSearch } from '@/components/api/asinKeyword.js'
import ADD_KEYWORDS_SUB from '@/components/template/view/keyword/monitoring/asinKeyword/sub/addKeywordsSub.vue'
import GOODS_INFO_SUB from '@/components/template/view/keyword/monitoring/asinInfo/sub/goodsInfoSub.vue'

export default {
	name: 'addKeywordSub',
	inject: ['F_alertMsg','F_windowLoading','F_getErrMSg'],
	components: {
		'goods-info-sub' : GOODS_INFO_SUB,
		'add-keywords-sub' : ADD_KEYWORDS_SUB,
	},
	props: {
		size : {
			default: 'medium'
		},
		keyword : {
			required:true
		},
		disabled : {
			default: false
		},
		asinInfo : {
			required:true
		}
	},
	data() {return{
		batchConfig : {
			startPage: 1,
			endPage: 3,
			categoryId: '',
			period: 6
		},
		addKeywordsdialogVisible : false,
		addKeywordsLoading: false,
		addkeywordObj : {
			asinId : null,
			keywordList: [],
		},
	}},
	computed:{},
	created() {
		this.$data.addkeywordObj.asinId = this.asinInfo.id
	},
	methods: {
		setKeywords : function(keywords){
			this.$data.addkeywordObj.keywordList = keywords
		},
		submitRetrieve: function(this_) {
			this_ = this_ || this
			if(this_.$data.addKeywordsLoading){
				return
			}
			// this_.$data.batchConfig.keyword = this_.keyword
			// let data = {
			// 	asinId: this_.asinId,
			// 	keyword: [this_.$data.batchConfig],
			// }
			// this_.$emit('starting')
			// 开启遮罩
			this_.$data.addKeywordsLoading = true
			api_submitSearch(this_.$data.addkeywordObj).then(res => {
				// this_.$emit('ending')
				this_.$emit('succeed',this_.keyword)
				// 关闭遮罩
				this_.$data.addKeywordsLoading = false
				this_.$data.addKeywordsdialogVisible = false
				this_.F_alertMsg('添加检索计划成功',2)
			}).catch(err => {
				// 关闭遮罩
				this_.$data.addKeywordsLoading = false
				// this_.$emit('ending')
				this_.F_alertMsg(this_.F_getErrMSg(err,'添加检索计划失败'),4)
			})
		},
	},
	watch: {}
}
</script>

<style>
</style>
